module.exports = __webpack_public_path__ + "static/media/mmExt5.4357f05d.jpg";